import { computed } from 'vue'
import { useStore } from 'vuex'

export function useFreeSamples() {
  const store = useStore()

  const freeSamples = computed(() => store.state.product?.freeSamples ?? [])
  const allowedFreeSamples = computed(() => store.state.product?.allowedFreeSamples ?? 0)
  const selectedSampleAmount = computed(() => store.state.product?.selectedSampleAmount ?? 0)
  const showFreeSamplesBlock = computed(
    () => Boolean(allowedFreeSamples.value && freeSamples.value?.length > 0)
  )

  const getFreeSamples = () => store.dispatch('product/getFreeSamples')
  const updateSelectedSamplesFromCart = (cart) =>
    store.dispatch('product/updateSelectedSamplesFromCart', cart)
  const openFreeSamplesModal = () => store.dispatch('product/openFreeSamplesModal')
  const closeFreeSamplesModal = () => store.dispatch('product/closeFreeSamplesModal')
  const incrementFreeSamplesModalKey = () => store.dispatch('product/incrementFreeSamplesModalKey')

  return {
    freeSamples,
    allowedFreeSamples,
    selectedSampleAmount,
    showFreeSamplesBlock,
    getFreeSamples,
    updateSelectedSamplesFromCart,
    openFreeSamplesModal,
    closeFreeSamplesModal,
    incrementFreeSamplesModalKey,
  }
}
